export class RevisionRecurrence {
    public name: string;
    public plannedValue: number;
    public percentage: number;
    public productionValueSincePlannedValueComputed: number;

    constructor(revisionRecurrence: any = {}) {
        this.name = revisionRecurrence.name || '';
        this.plannedValue = revisionRecurrence.plannedValue || 0;
        this.percentage = revisionRecurrence.percentage || 0;
        this.productionValueSincePlannedValueComputed =
            revisionRecurrence.productionValueSincePlannedValueComputed || 0;
    }
}
